import { PaymentProvider } from '../services/payments/types';
import { createStores } from './store/utils';

export const payment = createStores({
    selectedDepositProvider: undefined as unknown as PaymentProvider,
    selectedPayoutProvider: undefined as unknown as PaymentProvider,
    isPaymentFeeRequired: false,
});
